var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoc4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_422_133156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.83317 15.976V19.2566L3.90884 20.9483C2.67567 21.303 1.6665 22.64 1.6665 23.9233V25.09H14.4998",
    stroke: "#0B132B",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8332 15.976V19.2566L22.7552 20.9483C23.9918 21.303 24.9998 22.64 24.9998 23.9233V25.09H12.1665",
    stroke: "#0B132B",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.333 9.39009C20.333 13.6041 17.197 17.0224 13.333 17.0224C9.46551 17.0224 6.33301 13.6041 6.33301 9.38893C6.33301 5.17493 9.46551 1.75659 13.333 1.75659C17.197 1.75659 20.333 5.17493 20.333 9.39009Z",
    stroke: "#0B132B",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.261 8.05195C19.0943 9.21861 15.7577 9.16261 14.5012 6.81995C12.1678 9.15328 8.37616 9.15328 6.49316 7.82328M40.1667 15.9759V19.2566L34.2423 20.9483C33.0092 21.3029 32 22.6399 32 23.9233V25.0899H44.8333",
    stroke: "#0B132B",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1667 15.976V19.2566L53.0887 20.9483C54.3253 21.303 55.3333 22.64 55.3333 23.9233V25.09H42.5",
    stroke: "#0B132B",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.6665 9.39009C50.6665 13.6041 47.5305 17.0224 43.6665 17.0224C39.799 17.0224 36.6665 13.6041 36.6665 9.38893C36.6665 5.17493 39.799 1.75659 43.6665 1.75659C47.5305 1.75659 50.6665 5.17493 50.6665 9.39009Z",
    stroke: "#0B132B",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5567 8.04495C49.39 9.21161 46.0907 9.16261 44.833 6.81995C42.4997 9.15328 38.708 9.15328 36.8203 7.82328M24.9997 46.3349V49.5899L19.0753 51.2816C17.8422 51.6316 16.833 52.9733 16.833 54.2566V55.4233H29.6663",
    stroke: "#0B132B",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9997 46.3092V49.5899L37.9217 51.2815C39.1583 51.6339 40.1663 52.9732 40.1663 54.2565V55.4232H27.333",
    stroke: "#0B132B",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5 39.7223C35.5 43.9386 32.364 47.357 28.5 47.357C24.6325 47.357 21.5 43.9386 21.5 39.7223C21.5 35.5083 24.6325 32.09 28.5 32.09C32.364 32.09 35.5 35.5083 35.5 39.7223Z",
    stroke: "#0B132B",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.39 38.3199C34.2233 39.4866 30.924 39.4959 29.6663 37.1533C27.333 39.4866 23.5413 39.4866 21.6537 38.1566M9.83301 29.7566L15.6663 35.5899M47.1663 29.7566L41.333 35.5899",
    stroke: "#0B132B",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_422_133156"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(0.5 0.589966)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc4);
export default __webpack_public_path__ + "static/media/doc4.62d17dd0fdaaa3543cf949e40eaecffc.svg";
export { ForwardRef as ReactComponent };